export default "__VITE_ASSET__C9767pL2__"